// extracted by css-extract-rspack-plugin
export default {"onHoldFlag":"DonationOnHoldFlag_onHoldFlag__Ed04D","onHoldIcon":"DonationOnHoldFlag_onHoldIcon__1J6Do"};